import useWindowSize from './useWindowSize';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
var useThemeBreakpoints = function (_a) {
    var component = _a.component, staticSize = _a.staticSize;
    var currentBreakpoint = useWindowSize().currentBreakpoint;
    var theme = useContext(ThemeContext);
    var componentBreakpoints = theme.sizes[component];
    return componentBreakpoints[staticSize || currentBreakpoint] || {};
};
export default useThemeBreakpoints;
